module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.35.511a14dc.png";